<template>
  <employee-view/>
</template>

<script>
import EmployeeView from '../components/EmployeeView/index'
export default {
  components: {EmployeeView},

}
</script>

<style>

</style>
